<template>
  <div class="news-square" :class="{ingrid: ingrid}">
    <div class="square-filler">
      <img v-if="seen" :src="tileImageUrl" class="news-tile" :alt="item.title" 
        v-on:load="handleLoaded" :class="{loaded: loaded}" />
    </div>
    <div class="news-panel">
      <div class="news-panel-title" v-html="item.title"></div>
      <div class="news-panel-summary" v-html="item.summary"></div>
      <div class="artist-button-panel" v-if="artist">
        <small-button large v-on:click="visitPortfolio">{{ $nippets.replace('newsPage.visitPortfolio','fname', firstName )}}</small-button>
      </div>
      <div class="button-panel">
        <small-button large brown v-on:click="goStory()">{{ $nippets.newsPage.readTheStory }}</small-button>
      </div>
      <router-link class="plink" :to="item.permalink" title="permalink"><span style="visibility:hidden">{{ item.title }}</span></router-link>
    </div>
  </div>
</template>

<script>
import ViewablePanel from '@/mixins/ViewablePanel'

export default {
  mixins: [ ViewablePanel ],
  props: {
    item: Object,
    ingrid: Boolean
  },
  data () {
    return {
      artist: null,
      imsrc: '',
      loaded: false
    }
  },
  computed: {
    firstName: function () {
      if(this.artist) {
        let spl = this.artist.formatted_name.split(' ')
        if(spl.length > 0) return spl[0]
        return this.artist.formatted_name
      }
      return ''
    },
    tileImageUrl: function () {
      let timage = this.item.tile_image
      if(timage){
        timage = this.$k.forceFileExtension(timage, '.jpg')
        return this.$k.imagebase + 'images/news/' + this.item.news_id + '/crop/' + timage
      }
      return this.$k.randomBlurry()
    }
  },
  created () {
    this.init()
  },
  methods: {
    handleLoaded () {
     
      this.loaded = true
    },
    getMatchingArtist (keys) {
      for(var item of keys) {
        let a = this.$store.getters.getMatchingArtist(item)
        if(a) return a
      }
      return null
    },
    async init () {
      let keys = this.item.tags.split('#')
      await this.$store.dispatch('fetchArtists')
      this.artist = this.getMatchingArtist(keys)
      
    },
    goStory () {
      this.$emit('click', this.item)
    },
    visitPortfolio () {
      if(this.artist) {
        this.$ixr.push(this.$k.getPortfolioLink(this.artist))
      }
    }
  },
  watch: {
    item () {
      this.init()
    }
  }
}
</script>

<style>
.news-panel{
  background-color:#efefeadd;
  position:absolute;
  bottom:0;
  width:100%;
  box-sizing: border-box;
  padding:16px;
  transition:all 0.3s ease;
  
}


img.news-tile{
  width:100%;
  height:100%;
  position:absolute;
  top:50%;
  left:50%;
  transform:translate(-50%,-50%);
  transition:all 0.3s ease;
  opacity:0;
}

img.news-tile.loaded{
  opacity:1.0;
}


.news-square:hover img.news-tile{
  transform:translate(-50%,-50%) scale(1.05);
}


.news-panel-title{
  font-weight:500;
  color:#ce0e2d;
  font-weight:700;
  font-size:19px;
}


.news-panel-summary{
  height:0px;
  overflow:hidden;
  padding:0px;
  transition:all 0.2s ease;
  opacity:0;
}

.news-square{
  width:32.5%;
  position:relative;
  margin-bottom:1.5%;
  cursor:pointer;
  overflow:hidden;
}

.news-square.ingrid{
  width:100%;
  margin-bottom:0;
}

.news-square.nav{
  display:flex;
  flex-direction: column;
  justify-content: space-between;
}


.news-square:hover .news-panel-summary{
  height:auto;
  padding:8px 0px;
  opacity:1;
}

.news-square .artist-button-panel
{
  max-height:0;
  overflow:hidden;
  transition:all 0.2s ease;
  padding:0;
}

.news-square:hover .artist-button-panel{
  max-height: 90px;
  padding-top:10px;
}



.news-panel-summary a{
  color:#ce0e2d;
}

.news-panel-summary a:hover{
  text-decoration: underline;
}

.news-panel .button-panel{
  padding-top:8px;
}

.bgimage-faker{
  height:100%;
  min-height:300px;
  background-color:#ce0e2d;
  background-image:url('../../assets/img/x-spinner.svg');
  background-position:center center;
  background-size:50%;
}

a.plink{
  width:14px;
  height:14px;
  background-repeat: no-repeat;
  background-image: url('../../assets/img/circle-gold.svg');
  background-size: contain;
  cursor:pointer;
  opacity:0.5;
  display:block;
  position:absolute;
  bottom:10px;
  right:10px;
}

.plink:hover{
  opacity:0.9;
  background-image: url('../../assets/img/circle.svg');
}

@media screen and (max-width:1300px){
  .news-square{
    width:49%;
  }
}

@media screen and (max-width:900px)
{
  .news-square{
    width:100%;
  }
}
</style>